// extracted by mini-css-extract-plugin
module.exports = {"clipboard":"SearchStreamHeader__clipboard--jRC3P","bounce":"SearchStreamHeader__bounce--3jXa2"};